import styles from './index.module.less'
import { formatValue } from '@/utils/number'

interface IListItemProps {
  title: string
  value: string | number
  img: string
  fieldKey?: string
}

const ModuleItem = ({ title, value, img, fieldKey }: IListItemProps) => {
  // const navigate = useMeNavigate()
  // const { t } = useTranslation()

  return (
    <div className={styles.nodule_list_page}>
      <div>
        <div className={styles.title_text}>{title}</div>
        <div className={styles.value_text}>
          {fieldKey !== 'block_height' ? formatValue(value, true) : formatValue(value)}
        </div>
      </div>
      <img src={img} alt="" className={styles.img_icon} />
    </div>
  )
}

export default ModuleItem
